export default __webpack_public_path__ + "static/media/calendarActive.05f4a7e7.svg";